import { Device } from "./device.model";
import { Entity } from "./entity.model";
import { License } from "./license.model";
import { MultilevelItem } from "./multilevel-selector.model";
import { PackageType } from "./package-type.model";
import { PaginationRequest } from "./pagination.model";

export class Package {
  [key: string | number]: any;
  id!: number;
  ownerEntityId!: number;
  assignedEntityId!: number;
  packageTypeId!: number;
  packageStatusId!: number;
  packageCategoryId!: number;
  packagePeriodId!: number;
  deviceId!: number | null;
  assigned!: any;
  createdAt!: string;
  assignedAt!: string;
  upgradedAt!: string;
  updatedAt!: string;
  deletedAt!: string;
  testStartDate!: string;
  activationDate!: string;
  inactiveRequestDate!: string;
  inactiveDate!: string;
  renewalDate!: string;
  renewalInvoiceableDate!: string;
  renewalPersDate!: string;
  lastRenewalDate!: string;
  owner!: PackageOwner | null | undefined;
  ownerEntity!: Entity;
  assignedEntity!: Entity;
  packageType!: PackageType;
  status!: PackageStatus;
  category!: Category;
  period!: Period;
  device!: Device | null;
  licenses!: License[];
  defaultTestDays?: number;
  testDays?: number;
  remainingTestDays?: number;
  action?: string;
  deactive?: boolean | null;
  reactive?: boolean | null;
  upgrade?: number;
  cancelUpgrade?: number;
  packageUpgradeId?: number;
  packageUpgradeStatus?: PackageUpgradeStatus;
  packageOriginId?: number;
  packageOrigin!: PackageOrigin;
  reassignment?: { package?: Package, licenses?: License[] };
  comments?:string;
  saveComments?:boolean;
  canceledUpgradeId?:number;
  reassignNoDevice?: boolean;
}

export class PackageOrigin {
  id!: number;
  licenses!: string;
  packageOrigin!: PackageOrigin;
  packageOriginId?: number;
  renewalPersDate?: Date;
}

export class PackageStatus {
  id!: number;
  name!: string;
}

export class PackageUpgradeStatus {
  packageStatusId!: number;
}

export class PackageOwner {
  id!: number;
  name!: string;
  entityTypeId?: number;
}

export class Category {
  id!: number;
  name!: string;
}

export class Period {
  id!: number;
  name!: string;
}

export class PackageConfig {
  [key: string | number]: any;
  pagination!: PaginationRequest;
  partners!: MultilevelItem[];
  shops_selected!: Entity[];
  filters!: any;
  testId!: string;
  allSelected!: boolean;
}

export class PackageFilterConfig {
  [key: string | number]: any;
  entities!: any;
  packageType!: string;
  status!: string;
  packageInactive!: string
}
